export default {
  index: [
    {
      path: '/fwsptype',
      component: resolve => require(['./fwsptypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/fwsptype/_router.js